import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { IMultiSelectOption, IMultiSelectSettings, IMultiSelectTexts } from 'ngx-bootstrap-multiselect';
import { CanalVenda } from '../../domain';

@Component({
    selector: 'sgt-canal-venda-multiselect',
    templateUrl: './canal-venda-multiselect.component.html',
    styleUrls: ['./canal-venda-multiselect.component.less'],
})
export class CanalVendaMultiselectComponent implements OnInit {
    /** Canais Vendas selecionados */
    @Input() idsCanaisVendas: number[];
    /** Ao alterar a seleção dos canais de vendas */
    @Output() idsCanaisVendasChange = new EventEmitter<number[]>();

    // Settings
    settings: IMultiSelectSettings;
    @Input() pullRight = false;
    @Input() enableSearch = true;
    @Input() showCheckAll = true;
    @Input() showUncheckAll = true;
    @Input() dynamicTitleMaxItems = 0;
    @Input() fixedTitle = false;
    /** Se deve exibir o multiselect acima */
    @Input() dropup = false;
    /** Se deve desabilitar o multiselect */
    @Input() disabled = false;

    // Texts
    texts: IMultiSelectTexts;
    @Input() checkAll = 'Selecionar Todos';
    @Input() uncheckAll = 'Limpar';
    @Input() defaultTitle = 'Nenhum Canal de Venda';
    @Input() checked = 'Canal de Venda';
    @Input() checkedPlural = 'Canais de Venda';
    @Input() searchPlaceholder = 'Pesquisar...';
    @Input() allSelected = 'Todos Selecionados';
    @Input() searchEmptyResult = 'Nenhum canal de venda encontrado';
    @Input() searchNoRenderText = 'Digite para pesquisar';

    // Options
    options: IMultiSelectOption[] = [];

    ngOnInit() {
        // Settings
        this.settings = {
            pullRight: this.pullRight,
            enableSearch: this.enableSearch,
            containerClasses: `container-multiselect container-multiselect-canal-venda ${this.dropup ? 'dropup' : 'dropdown'}`,
            showCheckAll: this.showCheckAll,
            showUncheckAll: this.showUncheckAll,
            dynamicTitleMaxItems: this.dynamicTitleMaxItems,
            fixedTitle: this.fixedTitle
        };
        // Texts
        this.texts = {
            checkAll: this.checkAll,
            uncheckAll: this.uncheckAll,
            defaultTitle: this.defaultTitle,
            checked: this.checked,
            checkedPlural: this.checkedPlural,
            searchPlaceholder: this.searchPlaceholder,
            allSelected: this.allSelected,
            searchEmptyResult: this.searchEmptyResult,
            searchNoRenderText: this.searchNoRenderText
        };

        this.create();
    }

    /** Cria os canais de venda para o multiselect */
    private create() {
        this.options = [];
        const selects: IMultiSelectOption[] = [];

        CanalVenda.getAll().forEach(canalVenda => {
            selects.push({
                id: canalVenda.id,
                name: canalVenda.nome
            });
        });

        this.options = selects;
    }

    /** Ao alterar a seleção dos canais de venda */
    onChange() {
        this.idsCanaisVendasChange.emit(this.idsCanaisVendas);
    }
}
